/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Features_Closing_BodyInputs */

const en_portal_features_closing_body = /** @type {(inputs: Portal_Features_Closing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find a coach near you and book a first session, or start on your own today.`)
};

const pl_portal_features_closing_body = /** @type {(inputs: Portal_Features_Closing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znajdź trenera w pobliżu i zarezerwuj pierwszy trening albo zacznij sam już dziś.`)
};

/**
* | output |
* | --- |
* | "Find a coach near you and book a first session, or start on your own today." |
*
* @param {Portal_Features_Closing_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_features_closing_body = /** @type {((inputs?: Portal_Features_Closing_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Features_Closing_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_features_closing_body(inputs)
	return en_portal_features_closing_body(inputs)
});